<div *ngFor="let voucher of vouchers$ | async; let even = even; let index = index;" class="row-items table-content"
    [ngClass]="{ 'even':  (relatedCards$ | async).length %2 === 0 ? even : !even }" (click)="voucherSelected(voucher)"
    (keydown.enter)="voucherSelected(voucher)" role="link" tabindex="0">
    <div class="col-item w1 ">
        <span role="img" alt="" class="icon icon-voucher icon-card"></span>
    </div>

    <div class="col-item w9">
        <span class="title-card">{{( voucher?.product | translateObjectField:'name': locale)}}</span>
        <!-- <span class="amount-card-mob" *ngIf="!card.blocked">{{card.wallet_balance}} {{env.CURRENCY | translate }}</span>
                    <span class="amount-card-mob" *ngIf="card.blocked"
                        >{{'RELATED_CARD_LIST_LABEL_CARD_BLOCKED' | translate}}</span> -->
    </div>

    <div class="col-item w2 desktop-right amount-card">
        <!-- <span class="amount-card-desk" *ngIf="!card.blocked">{{card.wallet_balance}} {{env.CURRENCY | translate }}</span>
                    <span class="amount-card-desk" *ngIf="card.blocked"
                        >{{'RELATED_CARD_LIST_LABEL_CARD_BLOCKED' | translate}}</span>-->
        <span role="img" alt="" class="icon icon-arrow-right-link"></span>
    </div>
</div>
